import { render, staticRenderFns } from "./FileSelect.vue?vue&type=template&id=64b02f81"
import script from "./FileSelect.vue?vue&type=script&lang=js"
export * from "./FileSelect.vue?vue&type=script&lang=js"
import style0 from "./FileSelect.vue?vue&type=style&index=0&id=64b02f81&prod&lang=less"
import style1 from "./FileSelect.vue?vue&type=style&index=1&id=64b02f81&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports